'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
class $c_Lpresto_Fetcher$DecodeError extends $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception {
  constructor(message, request, response, cause) {
    super();
    this.X3 = null;
    this.X4 = null;
    this.X5 = null;
    this.X2 = null;
    this.X3 = message;
    this.X4 = request;
    this.X5 = response;
    this.X2 = cause;
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
  x() {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
  }
  p() {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
  }
  i(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lpresto_Fetcher$DecodeError)) {
      if ((this.X3 === x$0.X3)) {
        var x = this.X4;
        var x$2 = x$0.X4;
        var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
      } else {
        var $x_1 = false;
      }
      if (($x_1 && $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.X5, x$0.X5))) {
        var x$3 = this.X2;
        var x$4 = x$0.X2;
        return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  r() {
    return 4;
  }
  s() {
    return "DecodeError";
  }
  j(n) {
    switch (n) {
      case 0: {
        return this.X3;
        break;
      }
      case 1: {
        return this.X4;
        break;
      }
      case 2: {
        return this.X5;
        break;
      }
      case 3: {
        return this.X2;
        break;
      }
      default: {
        throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
      }
    }
  }
}
export { $c_Lpresto_Fetcher$DecodeError as $c_Lpresto_Fetcher$DecodeError };
function $isArrayOf_Lpresto_Fetcher$DecodeError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ie)));
}
export { $isArrayOf_Lpresto_Fetcher$DecodeError as $isArrayOf_Lpresto_Fetcher$DecodeError };
var $d_Lpresto_Fetcher$DecodeError = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$DecodeError, "presto.Fetcher$DecodeError", ({
  ie: 1,
  L: 1,
  F: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lpresto_Fetcher$DecodeError as $d_Lpresto_Fetcher$DecodeError };
//# sourceMappingURL=presto.-Fetcher$-Decode-Error.js.map
